//https://support.cookie-script.com/article/20-custom-events
//https://support.cookie-script.com/article/21-custom-functions
const initCookieScript = () => {
    //window.addEventListener('CookieScriptAcceptAll', function () {
    //
    //})
    //window.addEventListener('CookieScriptCategory-functionality', function () {
    //    
    //})
    //window.addEventListener('CookieScriptCategory-targeting', function () {
    //    
    //})
    window.addEventListener('CookieScriptCategory-performance', function () {
        const scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.src = 'https://www.googletagmanager.com/gtag/js?id=G-L7VDXFWSFD';
        const headElement = document.getElementsByTagName('head')[0];
        headElement.appendChild(scriptElement);
        const configScript = document.createElement('script');
        configScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-L7VDXFWSFD');
        `;
        headElement.appendChild(configScript);
    });
    //window.addEventListener('CookieScriptCategory-unclassified', function () {
    //    
    //})
};
